import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme, { opacity }: { opacity?: number }) => ({
    wrapper: {
        padding: "1.25rem 1.5rem",
    },
    placeholder: {
        backgroundColor: theme.colors.gray[4],
        borderRadius: ".25rem",
        height: "1.1875rem",
        opacity,

        "&:not(:last-child)": {
            marginBottom: "1rem",
        },
    },
}))
